import React from 'react';
import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

export function FeatureCard({ icon: Icon, title, description }: FeatureCardProps) {
  return (
    <motion.div 
      whileHover={{ y: -5 }}
      className="p-8 bg-gray-50 rounded-xl border border-gray-100"
    >
      <div className="w-12 h-12 bg-brand-100 rounded-lg flex items-center justify-center mb-4">
        <Icon className="text-brand-600" size={24} />
      </div>
      <h3 className="text-xl font-semibold mb-3">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </motion.div>
  );
}